// extracted by mini-css-extract-plugin
export default {"tutorialAnimation":"src-components-TutorialAnimation-module__tutorialAnimation--IDtQO","closed":"src-components-TutorialAnimation-module__closed--iAR0e"};